import styled from 'styled-components';
import CommonButton from '../../components/atoms/Buttons/CommonBtn';

export const Container = styled.div<{theme?: any}>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({theme}) => theme.lightBackground};
  text-align: center;
  margin-bottom: 30px;
`;

export const HeaderContainer = styled.div`
  flex-direction: row;
  text-align: center;
  height: 20px;
  margin-top: 25px;
`;

export const PageName = styled.text<{theme?: any}>`
  font-weight: bold;
  font-size: 16px;
  color: ${({theme}) => theme.background};
  line-height: 19px;
`;

export const BackButton = styled.button<{theme?: any}>`
  font-weight: normal;
  font-size: 16px;
  color: ${({theme}) => theme.grayText};
  line-height: 19px;
  position: absolute;
  left: 10px;
  background-color: transparent;
  border-width: 0;

  &:active {
    opacity: 0.3;
  }
`;

export const TitleContainer = styled.div`
  margin-top: 35px;
  padding-left: 20px;
  padding-right: 20px;
`;

export const Title = styled.text<{theme?: any}>`
  font-weight: normal;
  font-size: 28px;
  color: ${({theme}) => theme.darkText};
  line-height: 33px;
  text-align: center;
`;

export const CardsContainer = styled.div`
  text-align: center;
  padding-left: 50px;
  padding-right: 50px;
  margin-top: 20px;
`;

export const Button = styled(CommonButton)`
  width: 100%;
`;
